import { applyMiddleware, combineReducers, createStore } from "redux";
import { apiMiddleware } from "redux-api-middleware";
import { classificationsReducer } from "./Core/Reducers/classificationsReducer";
import { rankingReducer } from "./Ranking/rankingReducer";
import { gamesReducer } from "./Core/Reducers/gamesReducer";
import { teamDetailsReducer } from "./TeamDetails/teamDetailsReducer";
import { headToHeadReducer } from "./HeadToHead/headToHeadReducer";
import { markedSportsmenReducer } from "./Results/MarkedSportsen/markedSportsmenReducer";
import { lastUpdatedReducer } from "./LastUpdated/lastUpdatedReducer";
import { rankingTooltipsReducer } from "./RankingTooltips/rankingTooltipsReducer";
import adminMenuReducer from "./AdminMenu/adminMenuReducer";
import { calendarReducer } from "./Calendar/calendarReducer";
import { liveUpdateReducer } from "./LiveUpdate/liveUpdateReducer";
import { subleaguesReducer } from "./Subleagues/subleaguesReducer";
import { subleagueChatReducer } from "./SubleagueChat/subleagueChatReducer";
import { userReducer } from "./Core/Reducers/userReducer";
import { newsFeedReducer } from "./NewsFeed/newsFeedReducer";
import { gamesMenuReducer } from "./GamesMenu/gamesMenuReducer";
import { mobileReducer } from "./Core/Reducers/mobileReducer";
import thunk from "redux-thunk";

const createStoreWithMiddleware = applyMiddleware(
  thunk,
  apiMiddleware
)(createStore);

const reducer = combineReducers({
  classifications: classificationsReducer,
  games: gamesReducer,
  ranking: rankingReducer,
  markedSportsmen: markedSportsmenReducer,
  headToHead: headToHeadReducer,
  rankingTooltips: rankingTooltipsReducer,
  lastUpdated: lastUpdatedReducer,
  teamDetails: teamDetailsReducer,
  calendar: calendarReducer,
  subleagues: subleaguesReducer,
  user: userReducer,
  newsFeed: newsFeedReducer,
  liveUpdate: liveUpdateReducer,
  adminMenu: adminMenuReducer,
  gamesMenu: gamesMenuReducer,
  subleagueChat: subleagueChatReducer,
  mobile: mobileReducer,
});

let initGamesMenu = {};
let initStateTranslations = [];
let initStateUser = null;
let initStateUpdated = null;
const initNode = document.getElementById("init-state-games");
if (initNode) {
  initGamesMenu = JSON.parse(initNode.innerText);
}

const initNodeUser = document.getElementById("init-state-user");
if (initNodeUser) {
  initStateUser = JSON.parse(initNodeUser.innerText);
}

const initNodeTranslations = document.getElementById("init-state-translations");
let language = "en";
if (initNodeTranslations) {
  initStateTranslations = JSON.parse(initNodeTranslations.innerText);

  language = initStateTranslations.locale;

  if (initStateTranslations.locale == "cz") {
    initStateTranslations.locale = "cs";
  }
  if (initStateTranslations.locale == "dk") {
    initStateTranslations.locale = "da";
  }
}
const initNodeUpdated = document.getElementById("init-state-updated");
if (initNodeUpdated) {
  initStateUpdated = JSON.parse(initNodeUpdated.innerText);
}

export const i18nConfig = initStateTranslations;

const store = createStoreWithMiddleware(
  reducer,
  {
    games: {
      current: null,
      initLoading: true,
      updated: [],
    },
    gamesMenu: {
      list: [initGamesMenu],
      current: initGamesMenu,
      key: initGamesMenu.key,
    },
    lastUpdated: { ...initStateUpdated, status: null },
    user: { ...initStateUser, language },
  },
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
